import React, { useEffect, useState } from 'react';

import api from 'Components/_helpers/api';
import { FullFileBrowser } from 'chonky';
import { downloadFile } from 'Components/_helpers/utils';
import { Divider, Panel } from 'rsuite';
import { CargaModulo } from 'Components/CargaDTE/CargaModulo';
import {
  ChonkyActions,
  FileHelper
} from 'chonky';

export const Explorer = () => {
  const [, setLoading] = useState(false);
  const [uploadDisabled, setUploadDisabled] = useState(true);
  const [data, setData] = useState([]);

  const exportFile = (dir, file) => {
    console.log(file);
    downloadFile(`${api.getUri()}Download/File?dir=${encodeURIComponent(dir)}`, `${file.name}`);
  };

  // const [currentFolderId, setCurrentFolderId] = useState(rootFolderId);
  // const files = useFiles(currentFolderId);
  const [folderChain, setFolderChain] = useState([
    {
      id: 'temp',
      name: 'temp',
      isDir: true,
    },
  ]);

  const inputNames = ["NRD", "NDE", "NCE", "FEXE", "FE", "DCLE", "CRE", "CLE", "CCFE"];

  const handleFileAction = (data) => {
    if (data.id === ChonkyActions.OpenFiles.id) {
      const { targetFile, files } = data.payload;
      const fileToOpen = targetFile ?? files[0];

      if (fileToOpen && FileHelper.isDirectory(fileToOpen)) {
        let idx = folderChain.map((e) => e.id).indexOf(fileToOpen.id);
        if (idx > -1) {
          setFolderChain(folderChain.slice(0, idx + 1));
        } else setFolderChain([...folderChain, fileToOpen]);
      } else {
        exportFile([...folderChain, fileToOpen].map((f) => f.name).join('/'), fileToOpen);
      }

      setUploadDisabled(!inputNames.includes(targetFile.name));
    }

    if (data.id === ChonkyActions.OpenParentFolder.id) {
      const chain = [...folderChain];
      chain.pop();
      setFolderChain(chain);
    }

  };

  const getDirStructure = () => {
    setLoading(true);
    api.get(`${api.getUri()}App/DirStructure?dir=${encodeURIComponent(folderChain.map((f) => f.name).join('/'))}`).then((response) => {
      const files = response.data.map(f => ({
        ...f,
        draggable: false,
        droppable: false,
        dndOpenable: false
      }));
      setData(files);
      setLoading(false);
    });
  };

  useEffect(() => {
    getDirStructure();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [folderChain]);

  return (
    <Panel>
      <div className="table__hader">
        <h4>Explorador de archivos del sistema</h4>
      </div>
      <CargaModulo
        actionUrl={`${api.getUri()}Upload/Explorer/File?dir=${encodeURIComponent(folderChain.map((f) => f.name).join('/'))}`}
        fileUploaded={getDirStructure}
        disabled={uploadDisabled}
      />
      <Divider />
      <div style={{ height: 450 }}>
        <FullFileBrowser files={data} folderChain={folderChain} onFileAction={handleFileAction} />
      </div>
    </Panel>
  );
};
